import { render, staticRenderFns } from "./ChatFooter.vue?vue&type=template&id=d5e0a890&"
import script from "./ChatFooter.vue?vue&type=script&lang=js&"
export * from "./ChatFooter.vue?vue&type=script&lang=js&"
import style0 from "./ChatFooter.vue?vue&type=style&index=0&id=d5e0a890&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports